<template>
	<Panel hasShadow>
		<div class="flex-row flex-just-between">
			<div class="flex-row-align-center font-h2-medium">
				数据概览
				<span class="yx-color-info font-h6-regular ml-10">数据更新时间为T+1</span>
			</div>
			<p class="yx-color-info font-h6-regular ml-10 pointer" @click="skipUrl('/teamManage/achievements')" v-if="$auth.hasPermi('temManage:see-more')">
				更多
				<i class="el-icon-arrow-right"></i>
			</p>
		</div>
		<div class="flex-row-align-center flex-wrap">
			<div class="pt-24" v-for="(item, index) in content" :key="item.key" style="width: 20%; height: 78px">
				<div v-if="item.key === 'promoter_distribution'">
					<div class="flex-row-align-center" :key="1" style="width: 220px; transform: translate(-12px, -28px)">
						<div id="echartsPlatform" class="mt-18" style="width: 100px; height: 100px"></div>
						<div class="fz-12">
							<div class="color-gy-7 flex-row">
								推广者分布
								<Explain
									inline
									:size="14"
									:width="220"
									:content="'抖⾳：达播实际成交⾦额中来⾃抖⾳的订单⾦额\n快⼿：达播实际成交⾦额中来⾃快⼿的订单⾦额\n视频号：达播实际成交⾦额中来⾃视频号的订单⾦额'"
									placement="top"
									icon="icon-a-help-circlebangzhu-mian"
								></Explain>
							</div>
							<div class="mt-6">
								<div class="color-gy-8 flex-row-align-center mr-8">
									<span class="home_talentStatistic_echarts_spot" :style="{ background: generateChartsColor(3, 0) }"></span>
									达人
								</div>
								<div class="color-gy-8 flex-row-align-center mt-4">
									<span class="home_talentStatistic_echarts_spot" :style="{ background: generateChartsColor(3, 1) }"></span>
									二级团长
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else>
					<div class="flex-row-align-center yx-color-info font-h6-regular">
						{{ item.title }}
						<Explain v-if="item.explain" class="ml-4" icon="icon-a-help-circlebangzhu-mian" :content="item.explain" :size="14"></Explain>
					</div>
					<div v-if="!loading" class="Barlow-Bold" :class="index <= 4 ? 'fz-24' : 'fz-20'">
						<span v-if="item.price">¥</span>
						{{ item.value1 }}
					</div>
					<i v-if="loading" class="el-icon-loading fz-24 yx-color-primary"></i>
					<div class="flex-row-align-center yx-color-info font-h6-regular">
						<span class="mr-4">环比</span>
						<div v-if="item.value2">
							<i
								v-if="Number(item.value2) !== 0"
								:class="[Number(item.value2) > 0 ? 'el-icon-top yx-color-danger' : 'el-icon-bottom yx-color-success']"
							></i>
							<span
								class="ml-4"
								v-if="item.value2"
								:class="[Number(item.value2) > 0 ? 'yx-color-danger' : Number(item.value2) === 0 ? 'yx-color-info' : 'yx-color-success']"
							>
								{{ Math.abs(Number(item.value2)) | formatPrice4 }}%
							</span>
						</div>
						<span v-else>-</span>
					</div>
				</div>
			</div>
		</div>
	</Panel>
</template>

<script>
import { dataOverview } from '@/api/home';
import Explain from '@/components/common/explain';
import { formatPrice2 } from '@/filters';
import { mapGetters } from 'vuex';

export default {
	name: '',
	props: {
		params: {
			type: Object,
			default: _ => ({}),
		},
		authorityId: {
			type: String,
			default: '',
		},
		platformId: {
			type: Number,
		},
		userIds: {
			type: Array,
			default: () => [],
		},
		deptIds: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		Explain,
	},
	data() {
		return {
			content: [],
			generateChartsColor: utils.generateChartsColor,
			loading: false,
		};
	},
	computed: {
		...mapGetters(['isAllDataView', 'isDrPartnerDataView', 'isShopPartnerDataView']),
		dataMap() {
			return new Map([
				['total_amount', { key: 'total_amount', title: '支付金额', price: true, show: true, explain: '所选时间范围内，团长订单累计已支付的GMV' }],
				['promoter_distribution', { key: 'promoter_distribution', title: '推广者分布', show: true, explain: '2' }],
				['total_order', { key: 'total_order', title: '支付订单量', show: true, explain: '所选时间范围内，所有团长订单累计已支付的订单' }],
				['settle_amount', { key: 'settle_amount', title: '结算金额', price: true, show: true, explain: '所选时间范围内，团长订单累计已结算的GMV' }],
				['settle_order', { key: 'settle_order', title: '结算订单量', show: true, explain: '所选时间范围内，团长订单累计已结算的订单量' }],
				[
					'partner_estimated_commission',
					{
						key: 'partner_estimated_commission',
						title: '预估服务费收入',
						show: this.$auth.hasPermi('partner-result:home-data-overview-serviceFee'),
						price: true,
						explain: '所选时间范围内商家提供的预估服务费总计，包括已结算服务费、未结算服务费（未扣除技术服务费）',
					},
				],
				[
					'sec_estimated_commission',
					{
						key: 'sec_estimated_commission',
						title: '预估服务费支出',
						price: true,
						show: this.$auth.hasPermi('partner-result:home-data-overview-serviceFee') && this.$isPlatOr(this.platformId, ['All', 'Dy', 'Ks','Sp']),
						explain: '所选时间范围内给二级团长分成的预估服务费支出',
					},
				],
				[
					'estimated_commission',
					{
						key: 'estimated_commission',
						title: '预估提成',
						price: true,
						show: this.showCommission,
						explain: '所选时间范围内支付订单的提成，已扣除技术服务费',
					},
				],
				[
					'real_commission',
					{
						key: 'real_commission',
						title: '实际提成',
						price: true,
						show: this.showCommission,
						explain: '所选时间范围内已结算订单的提成，已扣除技术服务费',
					},
				],
				['order_product_count', { key: 'order_product_count', title: '出单商品', show: true, explain: '所选时间范围内有订单产生的商品数' }],
				['claim_anchor_count', { key: 'claim_anchor_count', title: '认领达人', show: true, explain: '所选时间范围内认领至员工私海的达人数' }],
				// 后续放开建联达人、成交达人即可
				// ['build_anchor_count', { key: 'build_anchor_count',title: '建联达人', show:true,explain: '所选时间范围内建联的达人数' }],
				['send_anchor_count', { key: 'send_anchor_count', title: '寄样达人', show: true, explain: '所选时间范围内寄样的达人数' }],
				// ['live_anchor_count', { key: 'live_anchor_count',title: '成交达人', show:true,explain: '所选时间范围内成交的达人数' }],
				['order_anchor_count', { key: 'order_anchor_count', title: '出单达人', show: true, explain: '所选时间段内有订单产生的达人数' }],
			]);
		},
		searchParameters() {
			return {
				authorityId: this.authorityId,
				platformId: this.platformId,
				userIds: this.userIds,
				deptIds: this.deptIds,
				from_time: this.params.from_time,
				to_time: this.params.to_time,
			};
		},
		showCommission() {
			// 1.全部数据视角或达人商务本人视角下，有商务提成权限 2.招商运营本人视角下，有招商提成权限
			return (
				((this.isAllDataView || this.isDrPartnerDataView) && this.$auth.hasPermi('partner-result:home-data-overview-commission')) ||
				(this.isShopPartnerDataView && this.$auth.hasPermi('partner-result:home-data-overview-zs'))
			);
		},
	},
	watch: {
		searchParameters: {
			handler(newValue, oldValue) {
				if (oldValue.from_time) {
					this.reset();
				}
			},
			deep: true,
		},
	},
	async mounted() {
		this.content = Array.from(this.dataMap.values()).filter(item => item.show);
		this.$nextTick(async () => {
			const { anchor_order_amount, institution_order_amount } = await this.getData();
			this.createEchartsPlatform();
			this.setEchartsPlatform(anchor_order_amount, institution_order_amount);
		});
	},
	methods: {
		createEchartsPlatform() {
			const dom = document.getElementById('echartsPlatform');
			const myChart = this.$echarts.init(dom, null, {
				renderer: 'canvas',
			});
			const option = {
				tooltip: {
					trigger: 'item',
					borderWidth: 0,
					formatter: params => {
						return (
							'<div style="margin-left:4px">' +
							`<div style='font-family: Barlow;font-size: 12px;display: flex;align-items: center;justify-content:space-between;color: #4E596A;line-height:20px;background:#fff;'>` +
							`<span style='font-family: DINAlternate-Bold;color: #1D2129;font-weight: 700;margin-right: 10px'>支付金额</span>` +
							`${params.percent}%</div>` +
							`<div style='font-family: Barlow;font-size: 12px;display: flex;align-items: center;justify-content:space-between;color: #1D2129;line-height:20px;background:#fff;margin-top:8px;'>` +
							'<div style="margin-right: 10px">' +
							(params.name === '达人'
								? '<div style="display: inline-block;border-radius: 100%;width: 6px;height: 6px;background:rgba(36,117,255,0.9) ;margin-right: 4px;"></div>'
								: '<div style="display: inline-block;border-radius: 100%;width: 6px;height: 6px;background:rgba(36,117,255,0.7) ;margin-right: 4px;"></div>') +
							`${params.name}` +
							`</div>` +
							`<span style='font-family: DINAlternate-Bold;color: #1D2129;font-weight: 700;'>￥${formatPrice2(
								Number(params.value).toFixed(2),
							)}</span>` +
							`</div>` +
							'</div>'
						);
					},
				},
				series: [
					{
						type: 'pie',
						radius: ['40%', '75%'],
						avoidLabelOverlap: false,
						label: { show: false },
						labelLine: { show: false },
						data: [
							{ value: 0, name: '达人' },
							{ value: 0, name: '二级团长' },
						],
						itemStyle: {
							color: function (colors) {
								var colorList = utils.generateChartsColor(3);
								return colorList[colors.dataIndex];
							},
						},
					},
				],
			};
			myChart.setOption(option);
			this.echartsPlatform = myChart;
		},
		setEchartsPlatform(DRGmv, TZGmv) {
			const option = this.echartsPlatform.getOption();
			option.series[0].data = [
				{ value: DRGmv, name: '达人' },
				{ value: TZGmv, name: '二级团长' },
			];

			this.echartsPlatform.setOption(option);
		},
		skipUrl(path) {
			const startEndTime = [this.params.from_time, this.params.to_time].join(',');
			const handLink = this.$router.resolve({
				path,
				query: {
					platformId: this.platformId,
					startEndTime,
					deptIds: this.deptIds.join(','),
				},
			});
			window.open(handLink.href, '_blank');
		},
		async reset() {
			const { anchor_order_amount, institution_order_amount } = await this.getData();
			this.setEchartsPlatform(anchor_order_amount, institution_order_amount);
		},
		async getData() {
			return new Promise((resolve, reject) => {
				this.getDataOverview(this.searchParameters)
					.then(({ content, anchor_order_amount, institution_order_amount }) => {
						this.content = content.filter(item => item.show);
						resolve({ anchor_order_amount, institution_order_amount });
					})
					.catch(error => {
						console.error('An error occurred: ', error);
					});
			});
		},
		getDataOverview(searchParameters) {
			return new Promise((resolve, reject) => {
				this.loading = true;
				dataOverview(searchParameters)
					.then(res => {
						if (res.code !== 0) return;
						this.loading = false;
						const map1 = this.dataMap;
						const map2 = new Map();
						map1.forEach((value, key) => {
							map2.set(key, {
								...value,
								value1: res.data[key],
								value2: res.data[key + '_rate'],
							});
						});
						const content = Array.from(map2.values());
						const anchor_order_amount = res.data.anchor_order_amount || 0;
						const institution_order_amount = res.data.institution_order_amount || 0;
						resolve({ content, anchor_order_amount, institution_order_amount });
					})
					.catch(error => {
						this.loading = false;
						reject(error);
					});
			});
		},
	},
};
</script>

<style lang="less" scoped>
.home_talentStatistic_echarts_spot {
	display: inline-block;
	border-radius: 100%;
	width: 6px;
	height: 6px;
	background: @color-primary;
	margin-right: 4px;
}
</style>
